var map = {
	"./de/impressum.mdx": [
		4557,
		5327
	],
	"./de/index.mdx": [
		89409,
		9409
	],
	"./de/rechtliche-grundlagen.mdx": [
		57109,
		7109
	],
	"./en/imprint.mdx": [
		24984,
		4984
	],
	"./en/index.mdx": [
		83465,
		3465
	],
	"./en/legal-framework.mdx": [
		47707,
		7707
	],
	"./fr/cadre-juridique.mdx": [
		11325,
		1325
	],
	"./fr/impressum.mdx": [
		85967,
		5967
	],
	"./fr/index.mdx": [
		93817,
		3817
	],
	"./it/colophon.mdx": [
		1630,
		1630
	],
	"./it/index.mdx": [
		97058,
		7058
	],
	"./it/quadro-giuridico.mdx": [
		96391,
		6391
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 51058;
module.exports = webpackAsyncContext;